import React, { FC, useMemo } from 'react';
import { Select } from 'components/antd';
import { Form } from 'components/index';
import { SelectProps } from 'antd';

interface ITagSelect extends SelectProps {
  data: any[];
  name: string;
  label: string;
}

export const TagSelect: FC<ITagSelect> = React.memo((props) => {
  const { data, name, label, size = 'large', ...rest } = props;
  const normalizedOptions = useMemo(() => {
    const map = new Map<string, string>();
    data.forEach((raw: any) => {
      const trimmed = raw.trim();
      const key = trimmed.toLowerCase();
      if (!map.has(key)) {
        map.set(key, trimmed);
      }
    });
    return Array.from(map.values()).map((val) => ({
      label: val,
      value: val,
    }));
  }, [data]);

  return (
    <Form.Item
      name={name}
      label={label}
      getValueFromEvent={(value: string[]) => {
        const seen = new Set<string>();
        return value
          .map((tag) => tag.trim())
          .map((tag) => {
            const lower = tag.toLowerCase();
            const match = normalizedOptions.find((opt) => opt.value.toLowerCase() === lower);
            return match ? match.value : tag;
          })
          .filter((tag) => {
            const lower = tag.toLowerCase();
            if (seen.has(lower)) return false;
            seen.add(lower);
            return true;
          });
      }}
    >
      <Select size={size} mode="tags" style={{ width: '100%' }} options={normalizedOptions} {...rest} />
    </Form.Item>
  );
});
